/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */

import { Typography } from 'antd';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import UserChargingSessions from 'components/Corporates/UserChargingSessions';

const { Title } = Typography;

const CorporateUsersChargingSession = ({
  userId,
  email,
  corporateId,
  phone,
}) => {
  const history = useHistory();
  const corporateData = {};
  // const { data: corporateData } = useFetchCorporateByID(corporateId);
  const [chargersData, setChargersData] = useState(null);
  // const {
  //   data: usersData,
  //   isLoading: isFetchingUsers,
  //   refetch: refetchUsers,
  // } = useFetchCorporateUsers(corporateId);

  // const data = [];

  // useMemo(() => {
  //   if (!chargersData) setChargersData(data);
  // }, [chargersData, data]);

  // useEffect(() => {
  //   if (!chargersData) setChargersData(data);
  // }, [chargersData, data]);

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            marginBottom: 20,
          }}
        >
          <LeftOutlined
            style={{ marginRight: '10px', cursor: 'pointer' }}
            onClick={() => history.goBack()}
          />
          <Title level={2} style={{ margin: '0px' }}>
            Users
            <span style={{ color: '#2375b8', marginLeft: 5 }}>
              {corporateData?.data?.CORPORATE_NAME}
            </span>
          </Title>
        </div>
      </div>
      <UserChargingSessions userId={userId} email={email} phone={phone} />
    </>
  );
};

export default CorporateUsersChargingSession;
